/**
 * Узкий неразрывный пробел
 */
export const NARROW_NO_BREAK_SPACE = '\u202F';

export const DECIMAL_SEPARATOR = ',';
